import { ShareButtonsConfig } from "@ui/context/component-config-context";
import vergeLight from "@ui/themes/theverge-light.css";
import { RecursivePartial } from "@voxmedia/duet-utils/typescript";

const shareButtonsConfig: RecursivePartial<ShareButtonsConfig> = {
  buttons: ["copy", "sharePopover", "preferredGoogleSource", "giftLink"],
  popoverButtons: ["facebook", "threads", "bluesky", "rss"],
  // Popovers should always use light theme
  popoverClassname: vergeLight,
  giftLinks: {
    subscriberMessaging: (giftCount: number) => {
      return (
        <>
          Your subscription includes gift articles each month. You have{" "}
          <strong>{Number.isInteger(giftCount) ? giftCount : "..."} </strong>
          left to share this month.
        </>
      );
    },
    nonSubscriberMessaging: (
      <>
        Gifting this article is one of the benefits of being a subscriber of The
        Verge. Subscribers can gift 5 articles every month.
      </>
    ),
    ctaText: "Subscribe Now",
    ctaLink: "https://www.theverge.com/subscribe",
    signInText: "Already a subscriber?",
  },
};

export default shareButtonsConfig;
